import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Categoria } from "../shared/models/Categoria.model";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class CategoriasService {
  private _categorias$ = new BehaviorSubject<Categoria[]>([]);
  public onCategoriasChange$ = this._categorias$.asObservable();

  constructor(private _translate: TranslateService) {}

  get categorias() {
    return this._categorias$.value;
  }

  set categorias(categorias: Categoria[]) {
    this._categorias$.next(
      categorias.map((cat) => ({
        ...cat,
        nombre: cat[this._translate.currentLang],
      }))
    );
  }
}
